<template>
  <!-- <router-view></router-view> -->
  <div class="APPPage">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { appBuild, appVer, site } from "./utils/version.js";
export default {
  beforeCreate() {
    let title = document.querySelector("head title");
    title.innerText = site + title.innerText;
    title.innerText += "(" + appVer + " Build " + appBuild + ")"
  },
};
</script>

<style lang="less" scoped>
.APPPage {
  height: 100%;
}
</style>
